import {
    SET_COLUMNS,
    SET_STATS_COLUMNS
} from './index';

import {columns} from '../components/Common/enum';
import {statsColumns} from '../components/Common/enum';


export function receivedColumns(columns) {
    return {
        type: SET_COLUMNS,
        payload: columns
    }
}

export function setColumns(filteredColumns) {
    return(dispatch) => {
        let visibleColumns = columns.filter(column => {
            if(!filteredColumns.includes(column.key) && column.isVisible)
            {
                return column;
            }
            return null;
        });
        dispatch(receivedColumns(visibleColumns));
    }
}

export function receivedStatsColumns(statsColumns) {
    return {
        type: SET_STATS_COLUMNS,
        payload: statsColumns
    }
}

export function setStatsColumns(filteredStatsColumns) {
    return(dispatch) => {
        let visibleStatsColumns = statsColumns.filter(statsColumn => {
            if(!filteredStatsColumns.includes(statsColumn.key) && statsColumn.isVisible)
            {
                return statsColumn;
            }
            return null;
        });
        dispatch(receivedStatsColumns(visibleStatsColumns));
    }
}


// WEBPACK FOOTER //
// ./src/actions/actions-filter-columns.js